import {useEffect, useState} from "react";
import {getPurchaseOrders} from "../../api/Api";
import {PurchaseOrderStatusType} from "../../api/Constants";
import {ExistingPurchaseOrderTable} from "../sales/ExistingPurchaseOrderTable";

export const ExistingPurchaseOrderView = ({onApiFail, refresh, onRefresh, props}) => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);

    useEffect(() => {
        getPurchaseOrders(PurchaseOrderStatusType.Fulfillment, true).then(r => {
            setPurchaseOrders(r);
        }).catch(e => {

        })
    }, [onApiFail, refresh]);

    return <div>
        <ExistingPurchaseOrderTable items={purchaseOrders} onRefresh={onRefresh} onApiFail={onApiFail} isFulfillment={true}/>
    </div>
}